import React, { Component, useState, useRef } from "react";
import {
  makeStyles,
  withStyles,
  useTheme,
  styled,
} from "@material-ui/core/styles";
import Save from "../../../../Assets/img/svg/save.svg";
import Cancel from "../../../../Assets/img/svg/cancel.svg";
import image from "../../../../Assets/img/svg/Image.svg";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { DragIndicator } from "@material-ui/icons";
import {
  TextField,
  InputBase,
  InputAdornment,
  IconButton,
  Checkbox,
} from "@material-ui/core";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import Autocomplete from "react-autocomplete";
import { useNavigate } from "react-router-dom";
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import styles from "../../../../Assets/jss/customStyle";
import List from "@material-ui/core/List";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import $ from "jquery";
import moment from "moment";
import InnerImageZoom from "react-inner-image-zoom";
import Delete from "../../../../Assets/img/svg/delete.svg";
import axios from "axios";
import API from "../../../../helpers/endpointService";
import del from "../../../../Assets/img/svg/Del.svg";
import { CssTextField, CssTextFieldLast, CssTextFieldRow } from "../../../custom/textField"
import { inspectionSystem } from "../../../Constants";
import { putShortSummaryDesc, filedeleteimage } from "../../../../actions/InspectionActions"
import { htmlDecode, htmlEncode, ReportDesc } from "../EncodeDecode.js"
import {warningAlert,successAlert} from "../../../custom/alert"
import { checkFileSize,checkFormat, successToast, errorToast, deleteToast  } from "../../../../actions/CommonFunction";

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

const useStyles = makeStyles((theme) => ({
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 2,
  },
  error: {
    color: "#f44336",
  },
  helperText: {
    "& p": {
      marginLeft: "0px !important",
    },
  },
  button: {
    background: "#FFFFFF",
    border: "none",
    boxSizing: "border-box",
    borderRadius: "7px",
  },
}));

const BootstrapError = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 0,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #f44336",
    fontSize: 16,
    padding: "10px 26px 10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
  },
}))(InputBase);

const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 0,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontSize: 16,
    padding: "10px 26px 10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
  },
}))(InputBase);

const names = ["Oliver Hansen", "Van Henry", "April Tucker", "Ralph Hubbard"];

const CheckboxWithBlackCheck = withStyles({
  root: {
    "& .MuiSvgIcon-root": {
      fill: "#FFFFFF",
      width: 20,
      height: 20,
      border: "1px solid #000000",
      "&:hover": {
        backgroundColor: "#FFFFFF",
      },
    },
    "&$checked": {
      "& .MuiIconButton-label": {
        position: "relative",
        zIndex: 0,
        backgroundColor: "#FFFFFF",
      },
      "& .MuiIconButton-label:after": {
        content: '""',
        height: 10,
        width: 10,
        position: "absolute",
        backgroundColor: "#000000",
        zIndex: -1,
      },
    },
  },
  checked: {},
})(Checkbox);

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

class AddDC extends Component {
  constructor(props) {
    super(props);
    this.inputFile = React.createRef();
    this.state = {
      isMobile: false,
      Docs: [],
      cancel: false,
      addDescription: {
        "Id": 0,
        "ShipId": 0,
        "SectionId": 0,
        "Description": "",
        "IsDeleted": true,
        "InspectionId": 0,
        "CreatedBy": "",
        "ModifiedBy": "",
        "ReportDescription": ""
      },
      addData: {
        "Id": 0,
        "ShipId": 0,
        "InspectionId": 0,
        "SectionId": 0,
        "Images": null,
        "UserEmail": JSON.parse(localStorage.getItem("currentUser")).email,
        "CreatedBy": "",
        "ModifiedBy": "",
      },
      DelIndex: 0,
      awsname: "",
      filename: "",
      dataList: [],
      showrow: false,
      index: 0,
      name: "",
      nameError: false,
      section: "",
      cost: "",
      DeleteId: 0,
      autoFocus: false,
      newpostdata: {
        "Id": 0,
        "ShipId": 0,
        "SectionId": 0,
        "InspectionId": 0,
        "Details": "",
        "Recommendation": "",
        "EstimatedCost": "",
        "IsDeleted": false,
        "CreatedBy": "",
        "ModifiedBy": "",
      },
      postdataname: {
        "Id": 0,
        "ShipId": 0,
        "Details": "",
        "Recommendation": "",
        "EstimatedCost": "",
        "IsDeleted": false,
        "CreatedBy": "",
        "ModifiedBy": "",
        "InspectionId": 0,
        "SectionId": 0
      },
      CancelSummary: "",
    };
  }
  componentDidMount() {
    let Shipid = parseInt(localStorage.getItem("DashId"));
    let inspectioid = parseInt(localStorage.getItem("InspectionId"));
    this.state.addData.ShipId = Shipid;
    this.state.addData.InspectionId = inspectioid;
    this.state.addData.ModifiedBy = localStorage.getItem("UserRoles");
    this.state.addData.CreatedBy = localStorage.getItem("UserRoles");
    this.state.addDescription.ShipId = Shipid;
    this.state.addDescription.InspectionId = inspectioid;
    this.state.addData.SectionId = inspectionSystem.CargoSystems;
    this.state.addDescription.SectionId = inspectionSystem.CargoSystems;
    this.state.newpostdata.ShipId = parseInt(localStorage.getItem("DashId"));
    this.state.newpostdata.InspectionId = parseInt(localStorage.getItem("InspectionId"));
    this.state.newpostdata.SectionId = inspectionSystem.CargoSystems;
    this.state.newpostdata.CreatedBy = localStorage.getItem("UserRoles");
    this.state.newpostdata.ModifiedBy = localStorage.getItem("UserRoles");
    this.setState({});
    const { dispatch } = this.props;
    this.dataTable();
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.interval = setInterval(() => {
      this.resize1();
    }, 10);
    if (Shipid !== 0 && inspectioid !== 0) {
      this.getSummaryDesc(Shipid, inspectioid);
    }
    this.getdcimage();
    window["summernote_addEditDesc"]();
  }

  dataTable = () => {
    let apiUrl = `${API.Get_Notable}?ShipId=${this.state.newpostdata.ShipId}&InspectionId=${this.state.newpostdata.InspectionId}&SectionId=${inspectionSystem.CargoSystems}`;
    // this.props.dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          this.state.dataList = [];
          this.setState({})
          if (response?.data.length !== 0) {
            this.state.dataList = response?.data;
            response.data.sort((a, b) => {
              return a.Id - b.Id;
            });
          }
          this.state.dataList.push({
            Id: 0,
            ShipId: this.state.newpostdata.ShipId,
            IsDeleted: false,
            ModifiedBy: "",
            CreatedBy: this.state.User,
            InspectionId: this.state.newpostdata.InspectionId,
            SectionId: inspectionSystem.CargoSystems,
            Details: "",
            Recommendation: "",
            EstimatedCost: "",
          })
          this.state.render = true;
          this.setState({})
        } else {
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {

        }
      });
  };

  handleInputChangeNotable = (e, str, val, index) => {
    if (val == "Details") {
      this.state.dataList.map((i) => (
        i.Id == str.Id ? i.Details = e.target.value : ""
      ))
      if (str.Id == 0 && e.target.value.length == 1 && e.target.value.trim() != "") {
        this.state.newpostdata.Details = e.target.value;
        this.state.newpostdata.Recommendation = str.Recommendation != "" ? str.Recommendation.trim() : "";
        this.state.newpostdata.EstimatedCost = str.EstimatedCost != "" ? str.EstimatedCost.trim() : "";
        this.state.newpostdata.ShipId = str.ShipId;
        this.state.newpostdata.IsDeleted = false;
        this.state.newpostdata.CreatedBy = this.state.User;
        this.state.newpostdata.InspectionId = str.InspectionId;
        this.state.newpostdata.SectionId = inspectionSystem.CargoSystems;
        this.setState({});
        this.post_data(this.state.newpostdata)
        // this.state.actNameFocus = true
      }
    }
    if (val == "Recommendation") {
      this.state.dataList.map((i) => (
        i.Id == str.Id ? i.Recommendation = e.target.value : ""
      ))
    }
    if (val == "EstimatedCost") {
      this.state.dataList.map((i) => (
        i.Id == str.Id ? i.EstimatedCost = e.target.value : ""
      ))
    }
    this.setState({})
  };

  handleFocusActChange = (e, str, val) => {
    this.setState({ actNameFocus: true, index: str.Id })
    if (str.Id == 0 && e.target.value.trim().length > 0) {
      document.getElementById('actName').selectionStart = e.target.value.trim().length;
      document.getElementById('actName').focus()
    }
  };

  handleFocusNameChange = (e, str, val) => {
    this.setState({ index: str.Id })
    if (e.target.value.trim().length > 0) {
      document.getElementById("actName" + str.Id).selectionStart = e.target.value.trim().length;
      document.getElementById("actName" + str.Id).focus()
    }
  };

  handleFocusActChange = (e, str, val) => {
    this.setState({ actNameFocus: true, index: str.Id })
    if (str.Id == 0 && e.target.value.trim().length > 0) {
      document.getElementById('actName').selectionStart = e.target.value.trim().length;
      document.getElementById('actName').focus()
    }
  };

  handlePasteChange = (event, str, val, index) => {
    if (str.Id == 0 && event.target.value.trim() != "") {
      this.state.newpostdata.Details = event.clipboardData.getData("text").trim();
      this.state.newpostdata.Recommendation = str.Recommendation.trim();
      this.state.newpostdata.EstimatedCost = str.EstimatedCost.trim();
      this.setState({})

    }
    this.state?.dataList?.map((i) => (
      i.Id == 0 ? i.Details.trim() == "" ? (
        this.post_data(this.state.newpostdata),
        this.state.actNameFocus = true
      )
        : "" : ""
    ))
    this.setState({})
  };

  handleFocusDescription = (e, str, val) => {
    this.setState({ index: str.Id })
    if (str.Id == 0 && e.target.value.trim().length > 0) {
      document.getElementById('DescName').selectionStart = e.target.value.trim().length;
      document.getElementById('DescName').focus()
    }
  };

  handleFocusDescriptioncost = (e, str, val) => {
    this.setState({ index: str.Id })
    if (str.Id == 0 && e.target.value.trim().length > 0) {
      document.getElementById('Desccost').selectionStart = e.target.value.trim().length;
      document.getElementById('Desccost').focus()
    }
  };

  postDataBlur = (e, str, val) => {
    if (val == "Details") {
      if (str.Id != 0 && e.target.value.trim() != "") {
        let data = {
          Id: str.Id,
          ShipId: this.state.newpostdata.ShipId,
          IsDeleted: false,
          ModifiedBy: localStorage.getItem("UserRoles"),
          InspectionId: this.state.newpostdata.InspectionId,
          SectionId: inspectionSystem.CargoSystems,
          Details: str.Details.trim(),
          Recommendation: str.Recommendation.trim(),
          EstimatedCost: str.EstimatedCost.trim(),
        }
        this.put_data(data, data.Id)
        this.setState({})
      }
      if (str.Id != 0 && e.target.value.trim() == "") {
        this.deleterow(str.Id);
      }
    }
    if (val == "Recommendation") {
      let data = {
        Id: str.Id,
        ShipId: this.state.newpostdata.ShipId,
        IsDeleted: false,
        ModifiedBy: localStorage.getItem("UserRoles"),
        InspectionId: this.state.newpostdata.InspectionId,
        SectionId: inspectionSystem.CargoSystems,
        Details: str.Details.trim(),
        Recommendation: e.target.value.trim(),
        EstimatedCost: str.EstimatedCost.trim()
      }
      if (data.Id != 0) {
        this.put_data(data, data.Id)
      }
    }
    if (val == "EstimatedCost") {
      let data = {
        Id: str.Id,
        ShipId: this.state.newpostdata.ShipId,
        IsDeleted: false,
        ModifiedBy: localStorage.getItem("UserRoles"),
        InspectionId: this.state.newpostdata.InspectionId,
        SectionId: inspectionSystem.CargoSystems,
        Details: str.Details.trim(),
        Recommendation: str.Recommendation.trim(),
        EstimatedCost: e.target.value.trim()
      }
      if (data.Id != 0) {
        this.put_data(data, data.Id)
      }
    }
    this.state.index = 0;
    this.state.FocusId1 = 0;
    this.state.FocusId2 = 0;
    this.setState({})
  };

  post_data = (data) => {
    let apiUrl = API.AddEdit_Notable;
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          this.state.dataList.map((i) => (
            i.Id == 0 ? i.Id = response.data : <></>
          ))
          this.setState({})
          this.state.actNameFocus = false;
          document.getElementById("actName" + response.data).focus()
          this.state.nameError = false;
          this.state.name = "";
          this.state.section = "";
          this.state.cost = "";
          this.state.showrow = false;
          let id = this.state.dataList.filter((i) => i.Id == 0)
          if (id.length == 0) {
            this.state.dataList.push({
              Id: 0,
              ShipId: this.state.newpostdata.ShipId,
              IsDeleted: false,
              ModifiedBy: "",
              InspectionId: this.state.newpostdata.InspectionId,
              SectionId: inspectionSystem.CargoSystems,
              Details: "",
              Recommendation: " ",
              EstimatedCost: "",
            })
          }
          this.setState({})

        } else {
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {

        }
      });
  };

  put_data = (data, id) => {
    let apiUrl = `${API.AddEdit_Notable}?id=${id}`;
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    })
      .then((response) => {

        if (response?.status === 200) {
          // this.state.autoFocus = false;
          // this.state.autoFocus1 = false;
          // this.setState({})
          // this.dataTable();
        } else {
        }
      })
      .catch((error) => {

        if (error?.response?.status === 401) {

        }
      });
  };

  OpenPopupNotable = (data) => {
    this.state.DeleteId = data;
    this.setState({})
    window.$("#deletepopup1").modal("show");
  };

  DeleteItemNotable = () => {
    this.deleterow(this.state.DeleteId)
    window.$("#deletepopup1").modal("hide");
  };

  deleterow = (data) => {
    this.props.dispatch({ type: "SHOW_LOADER", data: true })
    let apiUrl = API.Delete_Inspection + "?itemId=" + data;
    axios({
      method: "DELETE",
      url: apiUrl,
    })
      .then((response) => {

        if (response?.status === 200) {
          this.dataTable()
          this.props.dispatch({ type: "SHOW_LOADER", data: false })
          // successAlert("Deleted successfully.");
          deleteToast();
        } else {
          this.props.dispatch({ type: "SHOW_LOADER", data: false })
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {

        }
      });
  };

  componentWillUnmount() {
    clearInterval(this.interval);
    window.removeEventListener("resize", this.resize.bind(this));
    this.props.dispatch({ type: "RICHTEXT", data: false });
    this.props.dispatch({ type: "RICHTEXT1", data: false });
    $("#CARSYS1 .MuiListItemText-primary").addClass("spanTopBar");
    $("#CargoSystems1 .MuiListItemText-primary").removeClass("fw-bolder");
    $("#CargoSystems").addClass("d-none");
    $("#CargoSystems").removeClass("d-block");
    $("#CSL").removeClass("active-color");
    $("#CST").removeClass("fw-bolder");
  }
  sidebar = () => {
    if (this.state.cancel === true) {
      window.$("#cancelpopup1").modal("show");
    } else {
      this.props.navigate("/sidebar");
    }
  };
  SideBarCancel = () => {
    this.props.dispatch({ type: "CANCEL", data: false });
    window.$("#cancelpopup1").modal("hide");
    this.props.navigate("/sidebar");
  };
  resize = () => {
    if (window.innerWidth < 850) {
      this.setState({
        isMobile: true,
      });
    } else {
      this.setState({
        isMobile: false,
      });
    }
  };

  resize1 = () => {
    $("#CARSYS1 .MuiListItemText-primary").addClass("spanTopBar");
    $("#CargoSystems1 .MuiListItemText-primary").addClass("fw-bolder");
    $("#CargoSystems").removeClass("d-none");
    $("#CargoSystems").addClass("d-block");
    $("#CSL").addClass("active-color");
    $("#CST").addClass("fw-bolder");
  };
  AddCancel1 = () => {
    let SummeryResult = window["getsummernote_code"]();
    if ((this.state.cancel == true) || (this.state.CancelSummary != SummeryResult && SummeryResult != '<p><br></p>')) {
      window.$("#cancelpopup").modal("show");
    } else {
      this.props.dispatch({ type: "CANCEL", data: false });
      this.props.dispatch({ type: 'RICHTEXT', data: false });
      this.props.navigate(`/shiplist`);
    }
  };
  AddCancel = () => {
    this.props.dispatch({ type: "CANCEL", data: false });
    this.props.dispatch({ type: 'RICHTEXT', data: false });
    window.$("#cancelpopup").modal("hide");
    this.props.navigate("/shiplist");
  };
  adduploadimages = (Data, id) => {
    let apiUrl = `${API.AddEdit_Images}?id=${id ?? 0}&ShipId=${this.state.addData.ShipId}&InspectionId=${this.state.addData.InspectionId}&SectionId=${inspectionSystem.CargoSystems}&UserEmail=${this.state.addData.UserEmail}`;
    // this.props.dispatch({ type: "SHOW_LOADER", data: true });
    axios({
      method: "POST",
      url: apiUrl,
      data: Data,
    })
      .then((response) => {
        // this.props.dispatch({ type: "SHOW_LOADER", data: false });
        if (response?.status === 200) {
          this.getdcimage("save");
        } else {
          this.props.dispatch({ type: "SHOW_LOADER", data: true });
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
        // warningAlert("Something went wrong. Please try again.");
       errorToast();
       this.props.dispatch({ type: "CANCEL", data: true });
        if (error?.response?.status === 401) {
        }
      });
  }
  OpenPopup = (filename, awsname, id, index) => {
    this.state.filename = filename;
    this.state.awsname = awsname;
    this.state.DelIndex = index;
    this.setState({});
    window.$("#deletepopup").modal("show");
  };
  openView = (url, name, ind) => {
    this.state.fileUrl = url;
    this.state.filename = name;
    this.state.index = ind;
    this.setState({});
    window.$("#viewscreen").modal("show");
  };
  getSummaryDesc = (id, inspection) => {
    const { dispatch } = this.props;
    let apiUrl = `${API.Get_Richtext}?ShipId=${id}&InspectionId=${inspection}&SectionId=${inspectionSystem.CargoSystems}`;
    dispatch({ type: "SHOW_LOADER", data: true })
    axios.get(apiUrl)
      .then((response) => {
        if (response?.status === 200) {
          this.props.dispatch({ type: 'RICHTEXT', data: true })
          if (response?.data.Description !== null && response?.data.Id !== 0) {
            this.state.addDescription = response?.data;
            this.setState({})
            let result = htmlDecode(this.state.addDescription.Description);
            this.setState({
              CancelSummary: result
            })
            this.props.dispatch({ type: 'RICHTEXT_CANCEL', data: this.state.CancelSummary })
            window["getsummernote_code"](result)
          }
          dispatch({ type: "SHOW_LOADER", data: false })
        } else {

        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) { }
      });
  }
  addSummaryDesc = (data) => {
    let apiUrl = API.AddEdit_Richtext;
    this.props.dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        // this.props.dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          this.state.addDescription.Id = response?.data;
          this.setState({})
          let SummeryResult = window["getsummernote_code"]();
          this.state.CancelSummary = SummeryResult;
          this.props.dispatch({ type: 'RICHTEXT_CANCEL', data: SummeryResult })
          let formData = new FormData();
          let array = [];
          Array.from(this.state.Docs).forEach(async (a) => {
            if (a.AwsUniqueFileName == undefined) {
              formData.append("formFiles", a.fdata);
              array.push(a);
            }
          });
          this.setState({});
          if (array.length > 0) {
            this.adduploadimages(formData, this.state.addData.Id);
          } else {
            this.props.dispatch({ type: "SHOW_LOADER", data: false })
              //successAlert("Data saved successfully.");
            successToast();
          }
        } else {
          this.props.dispatch({ type: "SHOW_LOADER", data: false })
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false })
        // warningAlert("Something went wrong. Please try again.");
       errorToast();
       this.props.dispatch({ type: "CANCEL", data: true });
        if (error?.response?.status === 401) {
        }
      });

  }
  nextView = (ind) => {
    if (this.state.Docs.length === ind) {
      this.setState({
        index: 0,
      });
    } else {
      this.setState({
        index: ind,
      });
    }
  };
  preView = (ind) => {
    if (ind === -1) {
      this.setState({
        index: this.state.Docs.length - 1,
      });
    } else {
      this.setState({
        index: ind,
      });
    }
  };
  DeleteItem = (name) => {
    let tempData = [];
    this.state.Docs.map((i, index) => {
      if (this.state.DelIndex == index) {
        if (
          i.AwsUniqueFileName == this.state.awsname &&
          this.state.awsname != undefined
        ) {
          this.props.dispatch(
            filedeleteimage(this.state.addData.Id, this.state.awsname)
          );
        }
      }
      if (index != this.state.DelIndex) {
        tempData.push(i);
      }
    });
    this.state.Docs = tempData;
    this.setState({});
    window.$("#deletepopup").modal("hide");
  };
  getdcimage = (type) => {
    let Id = parseInt(localStorage.getItem("DashId"));
    let inspection = parseInt(localStorage.getItem("InspectionId"));
    let apiUrl = `${API.Get_Images}?ShipId=${Id}&InspectionId=${inspection}&SectionId=${inspectionSystem.CargoSystems}`;
    // this.props.dispatch({ type: "SHOW_LOADER", data: true });
    axios.get(apiUrl)
      .then((response) => {
        if (response?.status === 200) {
          if (response?.data?.Id !== 0) {
            this.state.addData.Id = response.data.Id;
            this.state.addData.ShipId = response.data.ShipId;
            this.state.addData.SectionId = response.data.SectionId;
            this.state.addData.InspectionId = response.data.InspectionId;
            this.state.addData.UserEmail = JSON.parse(localStorage.getItem("currentUser")).email;
            if (response.data?.Images.length > 0) {
              this.state.Docs = response.data?.Images;
            }
            this.setState({});
          }
          this.props.dispatch({ type: "SHOW_LOADER", data: false });
          if(type==="save"){
              //successAlert("Data saved successfully.");
            successToast();
          }
        } else {
          this.props.dispatch({ type: "SHOW_LOADER", data: false });
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };

  AttachFiles = (e) => {
    this.inputFile.current.click();
  };

  UploadFile = async (e) => {
    this.state.cancel = true;
    this.props.dispatch({ type: "CANCEL", data: true });
    await this.processFile(e.target.files);  

    checkFileSize(this.state.Docs);
  };

  processFile = async (files) => {

    var checkedFiles = await checkFormat(files);
  
    await Promise.all(
      Array.from(checkedFiles).map(async (a) => {
        let upload = {
          FileName: a.name,
          FileSize: a.size,
          check: false,
          fdata: a,
          FileUrl: await this.toBase64(a),
        };

        this.state.Docs.push(upload);
        this.setState({ Docs: this.state.Docs });
      })
    );      
    return true;
  }; 

  toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  AddSave = () => {
    const { dispatch } = this.props;
    let SummeryResult = window["getsummernote_code"]();
    this.props.dispatch({ type: "CANCEL", data: false });
    var check = checkFileSize(this.state.Docs);
    if(check == true)
    {
      if (this.state.addDescription.Id === 0) {
        this.state.addDescription.CreatedBy = localStorage.getItem("UserRoles");
        this.state.addDescription.ModifiedBy = "";
        this.state.addDescription.Description = htmlEncode(SummeryResult);
        let ReportResult = ReportDesc(SummeryResult);
        this.state.addDescription.ReportDescription = htmlEncode(ReportResult);
        this.setState({})
        this.addSummaryDesc(this.state.addDescription);
        this.setState({ cancel: false })
        this.props.dispatch({ type: "CANCEL", data: false });
      } else {
        this.state.addDescription.CreatedBy = "";
        this.state.addDescription.ModifiedBy = localStorage.getItem("UsesrRoles");
        this.state.addDescription.Description = htmlEncode(SummeryResult);
        let ReportResult = ReportDesc(SummeryResult);
        this.state.addDescription.ReportDescription = htmlEncode(ReportResult);
        this.setState({})
        this.putShortSummaryDesc(this.state.addDescription, this.state.addDescription.Id);
        this.props.dispatch({ type: "CANCEL", data: false });
      }
    }
    else
    {       
      this.props.dispatch({ type: "CANCEL", data: true });
    }
  };

  putShortSummaryDesc = (data, id) => {
    let apiUrl = `${API.AddEdit_Richtext}?id=${id}`;
    this.props.dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        if (response?.status === 200) {
          let SummeryResult = window["getsummernote_code"]();
          this.state.CancelSummary = SummeryResult;
          this.props.dispatch({ type: 'RICHTEXT_CANCEL', data: SummeryResult })
          let formData = new FormData();
          let array = [];
          Array.from(this.state.Docs).forEach(async (a) => {
            if (a.AwsUniqueFileName == undefined) {
              formData.append("formFiles", a.fdata);
              array.push(a);
            }
          });
          this.setState({});
          if (array.length > 0) {
            this.adduploadimages(formData, this.state.addData.Id);
          }
          else {
            this.props.dispatch({ type: "SHOW_LOADER", data: false })
              //successAlert("Data saved successfully.");
            successToast();
          }
        } else {
          this.props.dispatch({ type: "SHOW_LOADER", data: false })
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false })
        // warningAlert("Something went wrong. Please try again.");
       errorToast();
       this.props.dispatch({ type: "CANCEL", data: true });
        if (error?.response?.status === 401) { }
      });
  }


  render() {
    let { classes, menuToggle, PCPACTIVITY_LOOKUP, PCP_Add } = this.props;
    return (
      <>
        {this.state.isMobile ? (
          <>
            <div className="row w-100 mt-4 mob-topfixed ">
              <div className="col-6 mt-auto">
                <List
                  className="pt-3 mt-4 pl-3"
                  style={{ backgroundColor: "#F6F6F6" }}
                >
                  <ListItem onClick={this.sidebar}>
                    <ListItemText
                      id={"CARSYS" + "1"}
                      className="  textNaviIcon"
                      primary="Inspection Tasks"
                    />
                    <NavigateNextIcon
                      id="CARSYS"
                      className="naviIcon ml-1"
                      style={{ width: 23, height: 23 }}
                    />
                    <Divider className="border-bottom" />
                  </ListItem>
                </List>
              </div>
              <div className="col-6 pt-2 mt-5 ">
                <h4>Cargo Systems</h4>
              </div>
            </div>
          </>
        ) : (
          <></>
        )}
        <div
          className="ml-auto scroll-hide mt-138"
          style={{
            backgroundColor: "#FFFFFF",
            width: this.state.isMobile
              ? "100%"
              : menuToggle
                ? "calc(100% - 240px)"
                : "calc(100% - 64px)",
            marginTop: this.state.isMobile ? "" : -75,
          }}
        >
          {this.state.isMobile ? (
            <table className="dataTable border-top" width="100%">
              <tbody>
                <tr>
                  <td className="border-right text-center">
                    <i
                      className="fa fa-arrow-left cursorPointer"
                      onClick={this.AddCancel1}
                    ></i>
                  </td>
                  <td className="border-right text-center">
                    <button className={classes.button} onClick={this.AddSave}>
                      <img src={Save} style={{ marginTop: "-4px" }}></img>
                      &nbsp;Save
                    </button>
                  </td>
                  <td className="text-center">
                    <button
                      className={classes.button}
                      onClick={this.AddCancel1}
                    >
                      <img src={Cancel} style={{ marginTop: "-4px" }}></img>
                      &nbsp;Cancel
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          ) : (
            <table className="dataTable" width="100%">
              <tbody>
                <tr>
                  <td width="5%" className="border-right text-center">
                    <i
                      className="fa fa-arrow-left cursorPointer"
                      onClick={this.AddCancel1}
                    ></i>
                  </td>
                  <td width="95%">
                    <button className={classes.button} onClick={this.AddSave}>
                      <img src={Save} style={{ marginTop: "-4px" }}></img>
                      &nbsp;Save
                    </button>
                    <button
                      className={`${classes.button} pl-3`}
                      onClick={this.AddCancel1}
                    >
                      <img src={Cancel} style={{ marginTop: "-4px" }}></img>
                      &nbsp;Cancel
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          )}
          <div style={{ margin: this.state.isMobile ? "auto" : "5px" }}>
            {this.state.isMobile ? (
              ""
            ) : (
              <h6 className="col-12 mx-2 pt-2 ml-1">Cargo Systems</h6>
            )}
            <div className={this.state.isMobile ? "row mt-1 mx-0 pr-2 pt-1" : "row mt-1 mx-3 pr-2 pt-1"}>
              <div className={`row mx-1 mb-3 pt-2 p-0 ${this.state.isMobile ? "" : " "}`}>
                <div className={this.state.isMobile ? "col-12 pt-2 mt-1" : "col-12 p-0 pt-2 mt-1"}>
                  <div className="" id="summernote"></div>
                </div>
              </div>
              <h6 className="col-12 pt-3 px-0 ml-1">Key Notable Items</h6>
              <div className={`row mt-3 mx-1 mb-3 align-items-center p-0 ${this.state.isMobile ? "" : " "}`}>
                <div className={`table-responsive ${this.state.isMobile ? "" : "p-0"}`} style={{ width: "100%" }}>
                  <table id="Docstable" className="table table-borderless border-top border-bottom border-left border-right">
                    <thead>
                      <tr className="table-active">
                        <th className="border-top border-right" width="3%" style={{ minWidth: '3%', maxWidth: '3%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Items</span></th>
                        <th className="border-top border-right border-left" width="35%" style={{ minWidth: '35%', maxWidth: '35%' }}><span className="spandoc-thead">Details</span></th>
                        <th className="border-top border-right" width="34%" style={{ minWidth: '34%', maxWidth: '34%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Due Date / Recommendation</span></th>
                        <th className="border-top border-right" width="28%" style={{ minWidth: '28%', maxWidth: '28%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Estimated Cost (USD)</span></th>
                        <th className="border-top border-right" width="10%" style={{ minWidth: '10%', maxWidth: '10%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Action</span></th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state?.dataList && this.state?.dataList.map((i, index) => (
                        i.Id != 0 ?
                          <tr className="border-top">
                            <td className="border-right text-center align-middle"><span className="spandoc-td">{index + 1}</span></td>
                            <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left`} style={{ minWidth: '35%', maxWidth: '35%' }}>
                              <div className={(this.state.HoverId == i.Id || this.state.index == i.Id) ? "border-bg" : "border-bg-none"}>
                                <CssTextFieldRow
                                  multiline
                                  fullWidth
                                  variant="outlined"
                                  type="text"
                                  // autoFocus={this.state.index == i.Id ? true : false}
                                  id={"actName" + i.Id}
                                  onMouseEnter={(e) => this.setState({ HoverId: i.Id })}
                                  onMouseLeave={(e) => this.setState({ HoverId: 0 })}
                                  style={{ height: ($("#actName" + i.Id).outerHeight() > $("#actDesc" + i.Id).outerHeight()) ? ($("#actName" + i.Id).outerHeight() > $("#actcost" + i.Id).outerHeight()) ? $("#actName" + i.Id).outerHeight() + 13 : $("#actcost" + i.Id).outerHeight() + 13 : ($("#actDesc" + i.Id).outerHeight() > $("#actcost" + i.Id).outerHeight()) ? $("#actDesc" + i.Id).outerHeight() + 13 : $("#actcost" + i.Id).outerHeight() + 13, marginTop: "-2px" }}
                                  onFocus={(e) => this.handleFocusNameChange(e, i, 'Details')}
                                  // onFocusOut={(e) => this.setState({ index: 0 })}
                                  onChange={(e) => this.handleInputChangeNotable(e, i, 'Details', index)}
                                  onBlur={(e) => this.postDataBlur(e, i, 'Details')}
                                  value={i?.Details}
                                  InputProps={{
                                    className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                  }} />
                              </div>
                              {(i.Details == "") ?
                                <span className="pt-5" style={{ color: '#DD0000' }}>Details is required</span> : <></>}
                            </td>
                            <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right`} >

                              <div className={(this.state.HoverId1 == i.Id || this.state.FocusId1 == i.Id) ? "border-bg" : "border-bg-none"}>
                                <CssTextFieldRow
                                  multiline
                                  fullWidth
                                  variant="outlined"
                                  type="text"
                                  id={"actDesc" + i.Id}
                                  onMouseEnter={(e) => this.setState({ HoverId1: i.Id })}
                                  onMouseLeave={(e) => this.setState({ HoverId1: 0 })}
                                  onFocus={(e) => this.setState({ FocusId1: i.Id })}
                                  onFocusOut={(e) => this.setState({ FocusId1: 0, index: 0 })}
                                  onChange={(e) => this.handleInputChangeNotable(e, i, 'Recommendation')}
                                  style={{ height: ($("#actName" + i.Id).outerHeight() > $("#actDesc" + i.Id).outerHeight()) ? ($("#actName" + i.Id).outerHeight() > $("#actcost" + i.Id).outerHeight()) ? $("#actName" + i.Id).outerHeight() + 13 : $("#actcost" + i.Id).outerHeight() + 13 : ($("#actDesc" + i.Id).outerHeight() > $("#actcost" + i.Id).outerHeight()) ? $("#actDesc" + i.Id).outerHeight() + 13 : $("#actcost" + i.Id).outerHeight() + 13, marginTop: "-2px" }}
                                  onBlur={(e) => this.postDataBlur(e, i, 'Recommendation')}
                                  value={i?.Recommendation}
                                  InputProps={{
                                    className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                  }} />
                              </div>
                            </td>
                            <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right`} >

                              <div className={(this.state.HoverId2 == i.Id || this.state.FocusId2 == i.Id) ? "border-bg" : "border-bg-none"}>
                                <CssTextFieldRow
                                  multiline
                                  fullWidth
                                  variant="outlined"
                                  type="text"
                                  id={"actcost" + i.Id}
                                  onMouseEnter={(e) => this.setState({ HoverId2: i.Id })}
                                  onMouseLeave={(e) => this.setState({ HoverId2: 0 })}
                                  onFocus={(e) => this.setState({ FocusId2: i.Id })}
                                  onFocusOut={(e) => this.setState({ FocusId2: 0, index: 0 })}
                                  onChange={(e) => this.handleInputChangeNotable(e, i, 'EstimatedCost')}
                                  style={{ height: ($("#actName" + i.Id).outerHeight() > $("#actDesc" + i.Id).outerHeight()) ? ($("#actName" + i.Id).outerHeight() > $("#actcost" + i.Id).outerHeight()) ? $("#actName" + i.Id).outerHeight() + 13 : $("#actcost" + i.Id).outerHeight() + 13 : ($("#actDesc" + i.Id).outerHeight() > $("#actcost" + i.Id).outerHeight()) ? $("#actDesc" + i.Id).outerHeight() + 13 : $("#actcost" + i.Id).outerHeight() + 13, marginTop: "-2px" }}
                                  onBlur={(e) => this.postDataBlur(e, i, 'EstimatedCost')}
                                  value={i?.EstimatedCost}
                                  InputProps={{
                                    className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                  }} />
                              </div>
                            </td>
                            <td className="text-center align-middle">
                              <img src={Delete} className="cursorPointer" onClick={() => this.OpenPopupNotable(i.Id)} />
                            </td>
                          </tr> : <></>
                      ))}
                      {this.state?.dataList && this.state?.dataList.map((i, index) => (
                        i.Id == 0 ?
                          <tr className="border-top">
                            <td className="border-right text-center align-middle"><span className="spandoc-td"></span></td>
                            <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left`} style={{ minWidth: '35%', maxWidth: '35%' }}>
                              <CssTextFieldLast
                                multiline
                                fullWidth
                                variant="outlined"
                                type="text"
                                id="actName"
                                autoFocus={this.state.actNameFocus}
                                onFocus={(e) => this.handleFocusActChange(e, i, 'Details')}
                                onChange={(e) => this.handleInputChangeNotable(e, i, 'Details')}
                                onBlur={(e) => this.postDataBlur(e, i, 'Details')}
                                onPaste={(e) => this.handlePasteChange(e, i, 'Details')}
                                value={i?.Details}
                                InputProps={{
                                  className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                }} />
                              {(i.Details.trim() == "" && (i.Recommendation.trim() != "" || i.EstimatedCost.trim() != "")) ?
                                <span className="pt-5" style={{ color: '#DD0000' }}>Deatils is required</span> : <></>}
                            </td>
                            <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right`} style={{ minWidth: '34%', maxWidth: '34%' }}>
                              {(i.Recommendation == "") ?
                                <CssTextFieldLast
                                  multiline
                                  fullWidth
                                  variant="outlined"
                                  type="text"
                                  id="DescName"
                                  onFocus={(e) => this.handleFocusDescription(e, i, 'Recommendation')}
                                  onChange={(e) => this.handleInputChangeNotable(e, i, 'Recommendation')}
                                  onBlur={(e) => this.postDataBlur(e, i, 'Recommendation')}
                                  value={i.Recommendation}
                                  InputProps={{
                                    className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                  }} />
                                :
                                <CssTextFieldLast
                                  multiline
                                  fullWidth
                                  variant="outlined"
                                  type="text"
                                  id="DescName"
                                  onFocus={(e) => this.handleFocusDescription(e, i, 'Recommendation')}
                                  onChange={(e) => this.handleInputChangeNotable(e, i, 'Recommendation')}
                                  onBlur={(e) => this.postDataBlur(e, i, 'Recommendation')}
                                  value={i.Recommendation}
                                  InputProps={{
                                    className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                  }} />
                              }
                            </td>
                            <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right`} style={{ minWidth: '28%', maxWidth: '28%' }}>
                              {i.EstimatedCost == "" ?
                                <CssTextFieldLast
                                  multiline
                                  fullWidth
                                  variant="outlined"
                                  type="text"
                                  id="Desccost"
                                  onFocus={(e) => this.handleFocusDescriptioncost(e, i, 'EstimatedCost')}
                                  onChange={(e) => this.handleInputChangeNotable(e, i, 'EstimatedCost')}
                                  onBlur={(e) => this.postDataBlur(e, i, 'EstimatedCost')}
                                  value={i.EstimatedCost}
                                  InputProps={{
                                    className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                  }} />
                                : <CssTextFieldLast
                                  multiline
                                  fullWidth
                                  variant="outlined"
                                  type="text"
                                  id="Desccost"
                                  onFocus={(e) => this.handleFocusDescriptioncost(e, i, 'EstimatedCost')}
                                  onChange={(e) => this.handleInputChangeNotable(e, i, 'EstimatedCost')}
                                  onBlur={(e) => this.postDataBlur(e, i, 'EstimatedCost')}
                                  value={i.EstimatedCost}
                                  InputProps={{
                                    className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                  }} />
                              }
                            </td>

                          </tr> : <></>
                      ))}
                      {this.state.showrow ?
                        <tr className="border-top">
                          <td></td>
                          <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left`} style={{ minWidth: '35%', maxWidth: '35%' }}>
                            <CssTextFieldLast
                              type="text"
                              variant="outlined"
                              fullWidth
                              multiline
                              size="small"
                              InputProps={{
                                className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                              }}
                            />
                          </td>
                          <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-left`} style={{ minWidth: '34%', maxWidth: '34%' }}>
                            <CssTextFieldLast
                              type="text"
                              variant="outlined"
                              fullWidth
                              multiline
                              size="small"
                              InputProps={{
                                className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                              }}
                            />
                          </td>
                          <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-left`} style={{ minWidth: '28%', maxWidth: '28%' }}>
                            <CssTextFieldLast
                              type="text"
                              variant="outlined"
                              fullWidth
                              multiline
                              size="small"
                              InputProps={{
                                className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                              }}
                            />
                          </td>

                        </tr> : ""}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className={`row mx-1 mb-2 mt-2 align-items-center ${this.state.isMobile ? "" : "p-0"}`}>
                <div className={`row mx-1 mb-2 pt-2 p-0 text-row ${this.state.isMobile ? "" : " "}`}>
                  <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? " col-md-12" : "col-md-2 pt-4 pb-4"
                    }`}
                  >
                    <label
                      className={
                        this.state.isMobile ? "d-flex pt-2 m-0" : "float-end d-flex text-right m-0 "
                      }
                    >
                      Relevant Pictures&nbsp;:
                    </label>
                    <label  
                    style={{
                      whiteSpace : "nowrap",          
                      marginLeft : "14px", 
                      marginTop : "15px",
                      color : "#6c757d",           
                    }}
                    >
                    Note :  Uploaded files should be less than 30MB  
                    </label>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile
                      ? "col-md-12 pt-1 pb-3"
                      : "col-md-4 pt-4 pb-4 "
                      }`}
                  >
                    <TextField
                      variant="outlined"
                      size="small"
                      fullWidth
                      disabled
                      onChange={(e) => this.UploadFile(e)}
                      accept=".png,.jpg"
                      placeholder="Browse File"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment className="mr-0">
                            <IconButton
                              className="rotate p-0"
                              onClick={this.AttachFiles}
                            >
                              <AttachFileIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                        className: `border-radius ${classes.inputfieldAlign}`,
                      }}
                    />
                    <input
                      type="file"
                      hidden
                      multiple="multiple"
                      accept=".png,.jpg"
                      onChange={(e) => this.UploadFile(e)}
                      ref={this.inputFile}
                    />
                  </div>
                  <div className="col-12 col-sm-12 col-lg-6 col-xl-7"></div>
                  <div className="row mx-0">
                    <div
                      className={`col-12 col-sm-12  col-md-12 col-lg-12 col-xl-12 align-items-center ${this.state.isMobile
                        ? "col-md-12"
                        : "mt-2"
                        }`}
                    >
                      <div
                        className={
                          this.state.isMobile ? "row pl-2 pr-3" : "row px-1"
                        }
                      >
                        {this.state.Docs &&
                          this.state.Docs.map((i, ind) => {
                            return (
                              <div
                                className={`col-12 col-sm-6 col-lg-6 col-xl-4 align-items-center px-1 mb-2 ${window.innerWidth < 410
                                  ? "col-12"
                                  : this.state.isMobile
                                    ? "col-md-6"
                                    : "col-md-6"
                                  }`}
                              >
                                <div className="row d-flex gap">
                                  <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12  text-right">
                                    <img
                                      src={Delete}
                                      className="cursorPointer"
                                      onClick={() => {
                                        this.OpenPopup(
                                          i.FileName,
                                          i.AwsUniqueFileName,
                                          i.Id,
                                          ind);
                                      }}
                                    />
                                  </div>
                                  <div className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 text-right`}
                                    onClick={() => {
                                      this.openView(
                                        i.FileUrl,
                                        i.FileName,
                                        ind
                                      );
                                    }}
                                  >
                                    <img
                                      className="cursorPointer"
                                      src={i.FileUrl}
                                      width={
                                        window.innerWidth <= 290 ? "100%" :
                                          window.innerWidth <= 440 ? "257px" :
                                            window.innerWidth <= 575 ? "375px" :
                                              window.innerWidth <= 650 ? "244px" :
                                                window.innerWidth <= 876 ? "254px" : "267px"}
                                      onClick={() => {
                                        this.openView(
                                          i.FileUrl,
                                          i.FileName,
                                          ind
                                        );
                                      }}
                                      style={{
                                        height: this.state.isMobile ? "201px" : "201px",
                                        objectPosition: "50% 50%",
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="modal fade p-5 mt-5"
            id="cancelpopup"
            tabindex="-1"
            role="dialog"
            aria-labelledby="cancelpopupLabel"
            aria-hidden="true"
            style={{
              top: "13%",
              left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "",
            }}
          >
            <div className="modal-dialog" role="document">
              <div
                className={
                  this.state.isMobile ? "modal-content" : "modal-content p-3"
                }
              >
                <div className="modal-body pb-0">
                  <h1 className="text-center">
                    <img src={del}></img>
                  </h1>
                  <div className="text-center">
                    <h5 className="fw-bold">
                      The data will be lost. Do you really want to cancel?
                    </h5>{" "}
                  </div>
                </div>
                <div className="modal-footer border-top-0 m-auto">
                  <button
                    type="button"
                    className={
                      this.state.isMobile
                        ? "btn btn-secondary"
                        : " btn btn-secondary py-2 px-4"
                    }
                    data-dismiss="modal"
                    style={{ backgroundColor: "#499AC8", border: "none" }}
                    onClick={this.AddCancel}
                  >
                    <span className="">Yes</span>
                  </button>
                  <button
                    type="button"
                    id="closemodal1"
                    className={
                      this.state.isMobile
                        ? "btn btn-secondary"
                        : " btn btn-secondary py-2 px-4"
                    }
                    onClick={() => window.$("#cancelpopup").modal("hide")}
                    style={{
                      backgroundColor: "#EBEBEB",
                      border: "none",
                      color: "#111010",
                    }}
                  >
                    <span className="">No</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            className="modal fade p-5 mt-5"
            id="deletepopup"
            tabindex="-1"
            role="dialog"
            aria-labelledby="deletepopupLabel"
            aria-hidden="true"
            style={{
              top: "13%",
              left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "",
            }}
          >
            <div className="modal-dialog" role="document">
              <div
                className={
                  this.state.isMobile ? "modal-content" : "modal-content p-3"
                }
              >
                <div className="modal-body pb-0">
                  <h1 className="text-center">
                    <img src={del}></img>
                  </h1>
                  <div className="text-center">
                    <h5 className="fw-bold">
                      Are you sure you want to delete?
                    </h5>{" "}
                  </div>
                </div>
                <div className="modal-footer border-top-0 m-auto">
                  <button
                    type="button"
                    data-dismiss="modal"
                    className={
                      this.state.isMobile
                        ? "btn btn-secondary"
                        : " btn btn-secondary py-2 px-4"
                    }
                    style={{ backgroundColor: "#499AC8", border: "none" }}
                    onClick={() => this.DeleteItem()}
                  >
                    <span className="">Delete</span>
                  </button>
                  <button
                    type="button"
                    id="closemodal"
                    className={
                      this.state.isMobile
                        ? "btn btn-secondary"
                        : " btn btn-secondary py-2 px-4"
                    }
                    onClick={() => window.$("#deletepopup").modal("hide")}
                    style={{
                      backgroundColor: "#EBEBEB",
                      border: "none",
                      color: "#111010",
                    }}
                  >
                    <span className="">Cancel</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            class="modal fade image-view"
            id="viewscreen"
            tabindex="-1"
            role="dialog"
            aria-labelledby="deletepopupLabel"
            aria-hidden="true"
            style={{
              top: this.state.isMobile ? "25%" : "13%",
              left: this.state.isMobile ? "0%" : menuToggle ? "10%" : "",
              overflowY: "scroll",
              height: "90vh",
            }}
          >
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content ">
                <div className="modal-body pt-0 pb-2 pr-0 pl-0 ">
                  <div className="row">
                    <div className="col-12 ">
                      <div
                        className="cursorPointer float-end mr-3"
                        id="viewscreen"
                        onClick={() => {
                          window.$("#viewscreen").modal("hide");
                        }}
                      >
                        <button className={`${classes.button} px-0 hidefield`}>
                          &nbsp;Close
                        </button>
                      </div>
                    </div>
                    <div className="col-12 text-center">
                      <div
                        id="carouselExampleCaptions"
                        class="carousel slide"
                        data-bs-ride="carousel"
                        style={{}}
                      >
                        <div class="carousel-indicators"></div>
                        <div class="carousel-inner">
                          {this.state.Docs &&
                            this.state.Docs.map((i, ind) => (
                              <>
                                <div
                                  class={
                                    ind === this.state.index
                                      ? "carousel-item active col-12 text-center align-middle"
                                      : " align-middle carousel-item col-12 text-center"
                                  }
                                >
                                  <div>
                                    <InnerImageZoom
                                      moveType="drag"
                                      zoomScale={2}
                                      hideCloseButton={true}
                                      src={i.FileUrl}
                                      hasSpacer={true}
                                      afterZoomIn={() => {
                                        $("#viewscreen > div > div ").addClass(
                                          "Transparent"
                                        );
                                        $(".hidefield").removeClass("d-block");
                                        $(".hidefield").addClass("d-none");
                                      }}
                                      afterZoomOut={() => {
                                        $(
                                          "#viewscreen > div > div"
                                        ).removeClass("Transparent");
                                        $(".hidefield").addClass("d-block");
                                        $(".hidefield").removeClass("d-none");
                                      }}
                                    />
                                  </div>
                                  {this.state.Docs.length <= 1 ? (
                                    ""
                                  ) : (
                                    <>
                                      <button
                                        class="carousel-control-prev my-5 hidefield"
                                        type="button"
                                        data-bs-target="#carouselExampleCaptions"
                                        onClick={() => this.preView(ind - 1)}
                                        data-bs-slide="prev"
                                      >
                                        <span
                                          class="carousel-control-prev-icon black"
                                          aria-hidden="true"
                                        ></span>
                                        <span class="visually-hidden">
                                          Previous
                                        </span>
                                      </button>
                                      <button
                                        class="carousel-control-next  my-5 hidefield"
                                        type="button"
                                        data-bs-target="#carouselExampleCaptions"
                                        onClick={() => this.nextView(ind + 1)}
                                        data-bs-slide="next"
                                      >
                                        <span
                                          class="carousel-control-next-icon"
                                          aria-hidden="true"
                                        ></span>
                                        <span class="visually-hidden">
                                          Next
                                        </span>
                                      </button>
                                    </>
                                  )}
                                </div>
                              </>
                            ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="modal fade p-5 mt-5"
            id="deletepopup"
            tabindex="-1"
            role="dialog"
            aria-labelledby="deletepopupLabel"
            aria-hidden="true"
            style={{
              top: "13%",
              left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "",
            }}
          >
            <div className="modal-dialog" role="document">
              <div
                className={
                  this.state.isMobile ? "modal-content" : "modal-content p-3"
                }
              >
                <div className="modal-body pb-0">
                  <h1 className="text-center">
                    <img src={del}></img>
                  </h1>
                  <div className="text-center">
                    <h5 className="fw-bold">
                      Are you sure you want to delete?
                    </h5>{" "}
                  </div>
                </div>
                <div className="modal-footer border-top-0 m-auto">
                  <button
                    type="button"
                    data-dismiss="modal"
                    className={
                      this.state.isMobile
                        ? "btn btn-secondary"
                        : " btn btn-secondary py-2 px-4"
                    }
                    style={{ backgroundColor: "#499AC8", border: "none" }}
                    onClick={() => this.DeleteItem()}
                  >
                    <span className="">Delete</span>
                  </button>
                  <button
                    type="button"
                    id="closemodal"
                    className={
                      this.state.isMobile
                        ? "btn btn-secondary"
                        : " btn btn-secondary py-2 px-4"
                    }
                    onClick={() => window.$("#deletepopup").modal("hide")}
                    style={{
                      backgroundColor: "#EBEBEB",
                      border: "none",
                      color: "#111010",
                    }}
                  >
                    <span className="">Cancel</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            class="modal fade p-5 mt-5"
            id="cancelpopup1"
            tabindex="-1"
            role="dialog"
            aria-labelledby="cancelpopupLabel"
            aria-hidden="true"
            style={{
              top: "13%",
              left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "",
            }}
          >
            <div class="modal-dialog" role="document">
              <div
                class={
                  this.state.isMobile ? "modal-content" : "modal-content p-3"
                }
              >
                <div class="modal-body pb-0">
                  <h1 className="text-center">
                    <img src={del}></img>
                  </h1>
                  <div className="text-center">
                    <h5 class="fw-bold">
                      The data will be lost. Do you really want to cancel?
                    </h5>{" "}
                  </div>
                </div>
                <div class="modal-footer border-top-0 m-auto">
                  <button
                    type="button"
                    class={
                      this.state.isMobile
                        ? "btn btn-secondary"
                        : " btn btn-secondary py-2 px-4"
                    }
                    data-dismiss="modal"
                    style={{ backgroundColor: "#499AC8", border: "none" }}
                    onClick={this.SideBarCancel}
                  >
                    <span className="">Yes</span>
                  </button>
                  <button
                    type="button"
                    id="closemodal1"
                    class={
                      this.state.isMobile
                        ? "btn btn-secondary"
                        : " btn btn-secondary py-2 px-4"
                    }
                    onClick={() => window.$("#cancelpopup1").modal("hide")}
                    style={{
                      backgroundColor: "#EBEBEB",
                      border: "none",
                      color: "#111010",
                    }}
                  >
                    <span className="">No</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade p-5 mt-5"
          id="deletepopup1"
          tabindex="-1"
          role="dialog"
          aria-labelledby="deletepopupLabel"
          aria-hidden="true"
          style={{
            top: "13%",
            left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "",
          }}
        >
          <div className="modal-dialog" role="document">
            <div
              className={
                this.state.isMobile ? "modal-content" : "modal-content p-3"
              }
            >
              <div className="modal-body pb-0">
                <h1 className="text-center">
                  <img src={del}></img>
                </h1>
                <div className="text-center">
                  <h5 className="fw-bold">
                    Are you sure you want to delete?
                  </h5>{" "}
                </div>
              </div>
              <div className="modal-footer border-top-0 m-auto">
                <button
                  type="button"
                  data-dismiss="modal"
                  className={
                    this.state.isMobile
                      ? "btn btn-secondary"
                      : " btn btn-secondary py-2 px-4"
                  }
                  style={{ backgroundColor: "#499AC8", border: "none" }}
                  onClick={() => this.DeleteItemNotable()}
                >
                  <span className="">Delete</span>
                </button>
                <button
                  type="button"
                  id="closemodal"
                  className={
                    this.state.isMobile
                      ? "btn btn-secondary"
                      : " btn btn-secondary py-2 px-4"
                  }
                  onClick={() => window.$("#deletepopup1").modal("hide")}
                  style={{
                    backgroundColor: "#EBEBEB",
                    border: "none",
                    color: "#111010",
                  }}
                >
                  <span className="">Cancel</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

function mapStateToProps(state) {
  return {
    menuToggle: state.commonReducer.menuToggle,
    settings: state.commonReducer.settings || [],
  };
}

AddDC.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddDC))
);
